import ScanbotSDK from "scanbot-web-sdk/ui";

type BarcodeScannerConfiguration = InstanceType<
  typeof ScanbotSDK.UI.Config.BarcodeScannerConfiguration
>;

export function applyActionBarConfig(config: BarcodeScannerConfiguration) {
  config.actionBar.flashButton.visible = true;

  // Inactive state
  config.actionBar.flashButton.backgroundColor = "#7A000000";
  config.actionBar.flashButton.foregroundColor = "#FFFFFF";

  // Active state
  config.actionBar.flashButton.activeBackgroundColor = "#FFCE5C";
  config.actionBar.flashButton.activeForegroundColor = "#000000";

  config.actionBar.zoomButton.visible = true;

  config.actionBar.zoomButton.backgroundColor = "#7A000000";
  config.actionBar.zoomButton.foregroundColor = "#FFFFFF";

  config.actionBar.flipCameraButton.visible = true;

  config.actionBar.flipCameraButton.backgroundColor = "#7A000000";
  config.actionBar.flipCameraButton.foregroundColor = "#FFFFFF";

  config.topBar.title.text = "Escanear";
  config.topBar.cancelButton.text = "Cerrar";

  config.topBar.backgroundColor = "#D7192D";
  config.topBar.title.color = "#FFFFFF";
  config.topBar.cancelButton.foreground.color = "#FFFFFF";
}
